import { render, staticRenderFns } from "./SubProducts.vue?vue&type=template&id=34618358"
import script from "./SubProducts.vue?vue&type=script&lang=js"
export * from "./SubProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports